import { Section } from '../sections';

// Inline, single-stroke icons so tiles stay crisp and inherit the theme color
// (stroke="currentColor") instead of depending on bitmap badges.
const paths: { [key in Section]?: JSX.Element } = {
    Dashboard: (
        <>
            <path d="M4 11l8-6 8 6" />
            <path d="M6 10v9h12v-9" />
            <path d="M10 19v-5h4v5" />
        </>
    ),
    StudyMaterials: (
        <>
            <path d="M4 6c0-1 1-2 3-2s5 1 5 2v14c0-1-2-2-5-2s-3 1-3 1V6Z" />
            <path d="M20 6c0-1-1-2-3-2s-5 1-5 2v14c0-1 2-2 5-2s3 1 3 1V6Z" />
        </>
    ),
    OnlineLessons: (
        <>
            <rect x="3" y="5" width="18" height="13" rx="2" />
            <path d="M10 9.5v4l4-2-4-2Z" />
            <path d="M8 21h8" />
        </>
    ),
    Practice: (
        <>
            <path d="M9 6h9M9 12h9M9 18h9" />
            <path d="M4 6l1.2 1.2L7 5" />
            <path d="M4 12l1.2 1.2L7 11" />
            <circle cx="5" cy="18" r="1.2" />
        </>
    ),
    AiTutor: (
        <>
            <path d="M4 5h16v11H9l-4 3v-3H4V5Z" />
            <path d="M9 10h.01M12 10h.01M15 10h.01" />
        </>
    ),
    Community: (
        <>
            <circle cx="8" cy="9" r="3" />
            <circle cx="17" cy="10" r="2.3" />
            <path d="M3 19c0-3 2.5-5 5-5s5 2 5 5" />
            <path d="M14.5 19c0-2 1-3.6 3-3.6S20.5 17 20.5 19" />
        </>
    ),
    Account: (
        <>
            <circle cx="12" cy="8" r="4" />
            <path d="M4 20c0-4 4-6 8-6s8 2 8 6" />
        </>
    ),
};

export default function SectionIcon({ section }: { section: Section }) {
    return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"
            strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            {paths[section] ?? null}
        </svg>
    );
}
